/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { alertActions } from '../actions/Alerts';
import { Logo } from '../components/App/Header/Logo';
import { recoverPassword } from './service/calls';
import { validation } from './service/validations';
import FooterInfo from './FooterInfo';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(30),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  item: {
    paddingTop: '1em',
  },
  root: {
    fontSize: '1em',
  },
  all: {
    height: '100%',
  },
}));

export const ForgotPassword = ({ history }) => {
  const { t } = useTranslation();

  const classes = useStyles();

  const [inputs, setInputs] = useState({
    email: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const { email } = inputs;
  const dispatch = useDispatch();

  // reset login status
  useEffect(() => {
    if (submitted && !errors.email) {
      recoverPassword(inputs).then(() => {
        dispatch(alertActions.clear());
        setTimeout(() => history.push('/'), 10000);
        // setSubmitted(false);
      });
    }
  }, [submitted]);

  function handleChange(e) {
    const { name, value } = e.target;
    // dispatch(alertActions.clear());
    setErrors({});
    setInputs({ ...inputs, [name]: value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const err = validation({ email });
    setErrors(err);

    if (!err.email && email) {
    setSubmitted(true);
    }
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
      className={classes.all}
    >
      <Logo />
      <Container maxWidth="xs">
        <div className={classes.paper}>
          {submitted ? (
            <Grid
              container
              alignContent="center"
            >
              <Typography
                color="secondary"
                align="center"
                component="h1"
                variant="h6"
              >
                {t('auth.passwordinstructions')}
              </Typography>
            </Grid>
          ) : (
            <>
              <Typography color="secondary" align="left" component="h1" variant="h4">
                {t('auth.forgotpassword')}
              </Typography>
              <form className={classes.form} onSubmit={handleSubmit}>
                <Grid item xs={12} className={classes.item}>
                  <InputLabel>{t('auth.emailinput')}</InputLabel>
                  <TextField
                    autoComplete="off"
                    name="email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    required
                    error={!!errors.email}
                    defaultValue={inputs.email}
                    onChange={handleChange}
                    autoFocus
                    InputProps={{
                      autoComplete: 'off',
                      form: {
                        autoComplete: 'off',
                      },
                    }}
                  />

                  <FormHelperText className={classes.root} error={!!errors.email}>{errors.email && errors.email}</FormHelperText>
                </Grid>
                <Grid item xs={12}>
                  <Button className={classes.submit} type="submit" fullWidth variant="outlined" size="large" onClick={(e) => handleSubmit(e)} disabled={!!errors.email || !!errors.password}>
                    {t('auth.send')}
                  </Button>
                </Grid>
              </form>
            </>
          )}
          <Box mt={5}>
            <Link to="/">
              {t('auth.login')}
            </Link>
          </Box>
        </div>
      </Container>
      <FooterInfo />
    </Grid>
  );
};
